import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
//import { NavigationService } from '../navigation/navigation.service';
import {AppSettings} from '@app/common/app-setting';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) {  }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // debugger;
        // Here we apply theme dynamically
        const isLoggedIn = !!localStorage.getItem('currentUser');
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (!isLoggedIn || !currentUser) {
            this.router.navigate([AppSettings.LoginPath]);
            return null;
        }
        /*
        const theme = currentUser.ThemeKey || 'blue';
        // (!!!currentUser.ThemeKey || currentUser.ThemeKey === '') ? 'blue' : currentUser.ThemeKey;
        const classnameofcolor = 'skin-' + theme + ' sidebar-collapse sidebar-mini';
        const CheckColor = document.getElementById('bodyTheme').className = classnameofcolor;

        // End Here
        const isChangePassword = localStorage.getItem('ChangePasswordValidation');
        if (currentUser.Changepassword) {
            this.router.navigate(['./ChangePassword']);
            return null;
        }
        */
        return isLoggedIn;
    }
}


@Injectable()
export class PermissionsGuard implements CanActivate {
    constructor(private router: Router) {
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // debugger;
        var requestedURL = state.url;
        const entityType = JSON.parse(localStorage.getItem('EntityType')); 
        
        if ((requestedURL.startsWith('/merchant') || requestedURL.startsWith('/app/')) && entityType!=102) {
            this.router.navigate(['/notfound']);
            return null;
        } else if ((requestedURL.startsWith('/profile')) && entityType ==102) {
            this.router.navigate(['/notfound']);
            return null;
        }
        else if ((requestedURL.startsWith('/secure')) && entityType ==100) {
            this.router.navigate(['/notfound']);
            return null;
        }
        return true;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/shared/auth.guard.ts